import React from 'react';
import { Row, Col } from 'antd';
import UseFulFilesPresentational from './useful-files-presentational';

const UseFulFilesFunctional = () => {
	return <UseFulFilesPresentational />;
};
export default UseFulFilesFunctional;
